import { createContext, ReactNode, useEffect, useMemo, useState } from "react";

export interface INavigationContext {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const NavigationContext = createContext<INavigationContext>({
  open: false,
  setOpen: () => undefined,
});

// Must match the `lg:` breakpoint used to switch between the desktop sidebar and the
// mobile NcDrawer (see sidebar.tsx/navigation.tsx). The drawer's overlay backdrop isn't
// itself scoped to that CSS breakpoint, so if it's left open while resizing past it, this
// closes it — otherwise a full-screen overlay would be left showing with no visible panel.
const DESKTOP_BREAKPOINT_QUERY = "(min-width: 64rem)";

export const NavigationState = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const value = useMemo(() => ({ open, setOpen }), [open]);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(DESKTOP_BREAKPOINT_QUERY);
    const closeIfDesktopWidth = (event: MediaQueryListEvent) => {
      if (event.matches) setOpen(false);
    };
    mediaQueryList.addEventListener("change", closeIfDesktopWidth);
    return () => mediaQueryList.removeEventListener("change", closeIfDesktopWidth);
  }, []);

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
};
